import axiosInstance from "../../../api/AxiosInstance";
import { endpoints } from "../../../services/endpoints";
import { getProductsRequest, getProductsRequestError, getProductsRequestSuccess } from "../../slices/Product/GetProductSlice";

export const GetProductsApi = (search, page, limit, status) => async (dispatch) => {
    const queryParams = new URLSearchParams({
        page: page,
        search: search,
        limit: limit,
        status: status
    }).toString();

    const urlWithParams = `${endpoints.getProducts}?${queryParams}`;

    try {
        dispatch(getProductsRequest());
        axiosInstance({
            method: "GET",
            url: urlWithParams,
            headers: { "Content-Type": "application/json" },
        })
            .then((resp) => {
                return dispatch(getProductsRequestSuccess(resp?.data));
            })
            .catch((error) => {
                const _error = {
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                };
                return dispatch(getProductsRequestError(_error));
            });
    } catch (error) {
    }
};
